'use strict';

const Mn = require('backbone.marionette');
const Template = require('balus/ui/template/body/diagram/sidebar/description.hbs');
const Marked = require('balus/util/marked');

module.exports =  Mn.View.extend({
    template: Template,
    modelEvents: {
        'change': 'render'
    },

    templateContext: function() {
        const json = this.model.toJSON();
        return {
            description: Marked()(json.description ? json.description : '')
        }
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/diagram/sidebar/description.js